// extracted by mini-css-extract-plugin
export var aboveInput = "_j7-0";
export var actionButton = "_j7-5";
export var actionButtonContainer = "_j7-1";
export var actionIcon = "_j7-6";
export var aiInfoContainer = "_j7-2";
export var attachmentWrapper = "_j7-7";
export var bold = "_j7-3";
export var checkIcon = "_j7-8";
export var clickingRecipientBar = "_j7-11";
export var commentThreadSwitch = "_j7-a";
export var draftImage = "_j7-b";
export var draftImageContainer = "_j7-c";
export var draftImages = "_j7-e";
export var editButton = "_j7-g";
export var editor = "_j7-f";
export var editorContainer = "_j7-y";
export var editorErrorTooltipWrapper = "_j7-9";
export var headerDivider = "_j7-h";
export var icon = "_j7-i";
export var info = "_j7-j";
export var internal = "_j7-n";
export var internalDivider = "_j7-k";
export var internalMessage = "_j7-l";
export var messageInputCard = "_j7-m";
export var messageInputForm = "_j7-o";
export var messageInputFormInternal = "_j7-p";
export var options = "_j7-q";
export var publicMessageCustomer = "_j7-s";
export var publicMessageMerchant = "_j7-r";
export var removeImageButton = "_j7-d";
export var replyButtons = "_j7-t";
export var showSignatureButton = "_j7-u";
export var spinner = "_j7-v";
export var verticalButtonDivider = "_j7-4";
export var visibilitySelector = "_j7-w";
export var warning = "_j7-x";
export var wrappingText = "_j7-z";
export var writingInternalNoteTopBorder = "_j7-10";